'use client';

import { ThemeProvider, THEME_STORAGE_KEY } from '../components/ui/adapters/ThemeProvider';
import { Sonner } from '../components/ui/design-system';
import { AuthProvider } from '@repo/shared';
import { useRouter } from 'next/navigation';
import { supabaseAdapter } from '../adapters/supabase';
import { AuthService } from '@repo/shared';
import { useEffect } from 'react';

// Initialize auth service with web adapter once
AuthService.initialize(supabaseAdapter);

interface ProvidersProps {
  children: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  const router = useRouter();

  // Listen for system color scheme changes
  useEffect(() => {
    // This helps keep the system theme option in sync
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = () => {
      try {
        const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
        if (storedTheme === 'system') {
          // If using system theme, update the class when system preference changes
          if (mediaQuery.matches) {
            document.documentElement.classList.add('dark');
          } else {
            document.documentElement.classList.remove('dark');
          }
        }
      } catch (e) {
        console.error('Error handling color scheme change:', e);
      }
    };
    
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <ThemeProvider defaultTheme="system">
      <AuthProvider
        onSignIn={(event) => {
          // Only redirect to dashboard for actual sign-in events, not session restoration
          if (event === 'SIGNED_IN') {
            router.push('/dashboard');
          }
        }}
        onSignOut={() => router.push('/auth/login')}
      >
        {children}
        
        {/* 
          Add Sonner component at the app root for toast notifications
        */}
        <Sonner />
      </AuthProvider>
    </ThemeProvider>
  );
} 